import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getConfigAction } from 'root-redux/actions/common'
import { TAppDispatch } from 'root-redux/store/store'

export const useInitAppConfig = (): void => {
  const dispatch: TAppDispatch = useDispatch()

  useEffect(() => {
    dispatch(getConfigAction())
  }, [dispatch])
}
